import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonFilter'
})
export class JsonFilterPipe implements PipeTransform {

  transform(value: any, key1?: any, input?: any, key2?: any, arr?: any, key3?: any): any {
    if(value) {
      if(key2){
        let result: any = [];
        let temp: any = {};
        for(let val of arr) {
          if(val[key1] == input) {
            temp = val;
          }
        }
        for(let val of value) {
          if(val[key3] == temp[key2]) {
            result.push(val);
          }
        }
        return result;
      } else {
        let result: any = [];
        for(let val of value) {
          if(val[key1] == input) {
            result.push(val);
          }
        }
        return result;
      }
    }
  }

}
